import { Formik } from "formik"
import { Box, FormHelperText, Typography, useMediaQuery, useTheme } from "@mui/material"
import OTPInput, { InputProps } from "react-otp-input"
import { MFSubmitButton } from "../../lib/formik"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router"
import { GetConsentOtp, GetConsentOtpBody, GetCurrentConsentApplicationBody, VerifyConsentOtp } from "../../redux-store/actions/otpConsent"
import { showError } from "../../redux-store/actions/auth"
import { OtpTimer } from "../../lib/formik/OtpForm"

const intialValues: { OTP: string } = {
  OTP: '',
};

function Otp({ setIsVerified, id, otpResponse, referenceId, setShowOtp, setOtpResponse, numberOfTries, setNumberOfTries, userId }: { setIsVerified: React.Dispatch<React.SetStateAction<boolean>>; id: string; otpResponse: GetConsentOtpBody; referenceId: string; setShowOtp: React.Dispatch<React.SetStateAction<boolean>>, setOtpResponse: React.Dispatch<React.SetStateAction<GetConsentOtpBody>>, numberOfTries: number, setNumberOfTries: React.Dispatch<React.SetStateAction<number>>, userId: string }): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<string>('');
  const [{ verificationToken }, setVerifyOtpInfo] = useState({ verificationToken: '' });
  const [isLoading, setLoading] = useState<boolean>(false)

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isXs = useMediaQuery(theme.breakpoints.up('xs'));

  const handleSubmit = async (values: { OTP: string }, { resetForm }: { resetForm: () => void }) => {

    const { OTP } = values;
    try {
      setLoading(true)

      if (!OTP || OTP.length !== 6) {
        setError('Enter OTP');
        return;
      }
      if (!otpResponse?.verificationToken) {
        dispatch(showError('Something went wrong, Please refresh the page and try again'));
        return;
      }
      const res = await dispatch(VerifyConsentOtp({ applicantId: id, otp: OTP, verificationToken: otpResponse?.verificationToken, referenceId, otpRefNo: otpResponse?.otpRefNo ?? '' })) as unknown as GetCurrentConsentApplicationBody;
      if (res?.message) {
        setIsVerified(true);
        setLoading(false);
        setShowOtp(false);
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
      resetForm();
    }
  };

  const handleResendOTP = async () => {
    try {
      const response = await dispatch(GetConsentOtp({ applicantId: id, referenceId: referenceId })) as unknown as GetConsentOtpBody;
      if (response?.phone) {
        setOtpResponse(response);
        setNumberOfTries(response?.numberOfOTPTries ?? 0);
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  }
  return (

    <Box
      sx={{
        bgcolor: 'grey.50',
        height: { xs: 'unset', sm: 'unset' },
        width: 'clamp(300px, 70%, 500px)',
        px: { xs: '25px', sm: '60px' },
        py: '40px',
        mb: 2,
        borderRadius: '10px',
        boxShadow: '0px 3.29214px 6.58427px rgba(27, 27, 27, 0.16)',
      }}>
      <Typography
        component="h1"
        variant="h1"
        sx={{
          // fontFamily: 'Poppins, sans-serif',
          // fontSize: 28,
          // fontWeight: 600,
          color: 'primary.main',
          mb: '40px',
          textAlign: 'center',
        }}>
        Verify Consent OTP
      </Typography>
      <Formik initialValues={intialValues} onSubmit={handleSubmit}>
        {({ values, setValues, handleSubmit }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Typography sx={{ color: 'primary.main', textAlign: 'center', mb: 3.5 }} variant="overline_600">
              An OTP has been sent to your mobile number
              {otpResponse?.phone && (<Typography component="span" variant="overline_600">{` ${otpResponse?.phone} `}</Typography>)}
              {otpResponse?.email && (
                <Typography component="span" variant="overline_600">
                  and email Id{' '}
                  <Typography component="span" sx={{ wordBreak: 'break-all' }} variant="overline_600">
                    {' '}
                    {otpResponse?.email}
                  </Typography>
                </Typography>
              )}
            </Typography>
            <Box
              sx={{
                mb: 0,
                '.otp-input': {
                  input: {
                    width: { xs: '37px !important', md: '45px !important' },
                    fontSize: { xs: '20px !important', md: '30px !important' },
                    margin: { xs: '2px !important', md: '4px !important' },
                  },
                },
              }}>
              <OTPInput
                inputType='number'
                renderInput={(inputProps: InputProps) => <input {...inputProps} type='password' style={{ ...inputProps.style }} disabled={isLoading} />}
                value={values.OTP}
                // isDisabled={isLoading}
                onChange={(OTP: string) => setValues({ OTP })}
                numInputs={6}
                // hasErrored={!!error}
                // isInputNum={true}
                // isInputSecure={true}
                shouldAutoFocus={true}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                  // flexWrap: 'wrap',
                }}
                inputStyle={{
                  width: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  height: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  // padding: '5px 10px',
                  // // width: '45px',
                  borderRadius: '5px',
                  fontSize: !isSm ? '22px' : '30px',
                  borderColor: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                  color: error ? `${theme.palette.common.red}` : `${theme.palette.text.primary}`,
                  outline: 'none'
                }}
                renderSeparator={() => (
                  <span style={{ width: '6px' }}></span>
                )}

              // errorStyle={{ border: '2px solid red', color: 'red' }}
              // focusStyle={{ outline: 'none' }}
              // className="otp-input"
              />
              {!!error && (
                <FormHelperText error sx={{ mt: 2, textAlign: 'center', fontSize: '14px' }}>
                  {error}
                </FormHelperText>
              )}
            </Box>
            <Box
              sx={{
                '.MuiTypography-root, .MuiButton-root': {
                  textAlign: 'center',
                },
              }}>
              <OtpTimer onResend={handleResendOTP} disabled={isLoading} numberOfTries={numberOfTries} />
            </Box>
            {/* <Box
              sx={{
                fontSize: 14,
                color: theme.palette.error[500],
                textAlign: 'center',
                marginBottom: "20px",
                mt: 2
              }}>
              Note: You can request up to two SMS OTPs and one Voice OTP per hour.
            </Box> */}
            <Typography variant="body_400" color={'text.secondary'} textAlign={'center'} mt={3} mb={2}>
              {/* Note: You can request up to two SMS OTPs and one Voice OTP per hour. */}
              Note: You can request up to three SMS OTPs per hour.
            </Typography>
            <Box sx={{ textAlign: 'center' }}>
              <MFSubmitButton label="Submit" loadingEnable={isLoading} />
            </Box>
          </Box>
        )}
      </Formik>
    </Box>

  )
}

export default Otp